export default __webpack_public_path__ + "static/media/srisailamVisitSixteen.d7eea88d.jpg";